// src/pages/Subscription.jsx
import React, { useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { subscription } from '../services/api';
import { loadStripe } from '@stripe/stripe-js';

const stripePromise = loadStripe('pk_test_51QjHeGJ88I6y5jTaBg4qo7ps7p8R5AZC33srPtvTvE9ef5UZtDAlXrwNvR03qOajn9NFzeVbnockxABp42gvoZWZ00sjYCBw8E');

const Subscription = () => {
  const [processing, setProcessing] = useState(false);
  const [currentPlan, setCurrentPlan] = useState(null);
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    const fetchCurrentPlan = async () => {
      try {
        const response = await subscription.getCurrentPlan();
        setCurrentPlan(response.data);
      } catch (error) {
        console.error('Error fetching current plan:', error);
      }
    };

    if (user) {
      fetchCurrentPlan();
    }
  }, [user]);
 
 const plan = [
   {
     id: '24hr',
     productId: '',
     priceId: 'price_1Qkk9zJ88I6y5jTa6Cl8gXC8',
     name: '24hr gamepass',
     price: '$1.99',
     duration: '24hour',
     features: [
       'Full HD streaming',
       'All games access',
       'No commitment'
     ]
   },
   {
    id:'7day',
    productId: '',
    priceId:'price_1QkkAaJ88I6y5jTaH7jrDwqh',
     name: '7day gamepass', 
     price: '$3.99',
     duration: '7days',
     features: [
       'Full HD streaming',
       'All games access',
       'No commitment',
     ]
   },
   {
    id:'monthly',
    productId: '',
    priceId:'price_1Qpj2zJ88I6y5jTaHjP9rt79',
     name: 'Monthly gamepass',
     price: '$5.99', 
     duration: '30 days',
     features: [
       '4K streaming',
       'All games access',
       'Save game progress',
       'Exclusive discounts'
     ]
   }
 ];

 const handleSubscribe = async (priceId) => {
  setProcessing(true);
  try {
    const stripe = await stripePromise;
    const response = await subscription.createCheckoutSession(priceId);
    await stripe.redirectToCheckout({ sessionId: response.data.id });
  } catch (error) {
    console.error('Subscription error:', error);
    setProcessing(false);
  }
};

  return (
<div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-center mb-12">Choose Your Gaming Plan</h1>
      {currentPlan && (
        <div className="mb-8">
          <h2 className="text-xl font-bold mb-2">Current Plan: {currentPlan.name}</h2>
          <p className="text-gray-600">
            {currentPlan.active ? 'Your subscription is active.' : 'Your subscription has expired.'}
          </p>
        </div>
      )}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {plan.map((plan) => (
          <div
            key={plan.id}
            className="bg-white rounded-lg shadow-lg p-6"
          >
            <h2 className="text-2xl font-bold mb-4">{plan.name}</h2>
            <p className="text-4xl font-bold mb-4">{plan.price}</p>
            <p className="text-gray-600 mb-6">{plan.duration}</p>
            <ul className="space-y-3 mb-8">
              {plan.features.map((feature, index) => (
                <li key={index} className="flex items-center">
                  <svg className="w-5 h-5 text-green-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  {feature}
                </li>
              ))}
            </ul>
            <button
            onClick={() => handleSubscribe(plan.priceId)}
            disabled={processing}
            className="w-full bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition-colors duration-200"
            >
            {processing ? 'Processing...' : 'Subscribe Now'}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
 };
 
 export default Subscription;